import React from "react";
import axios from 'axios';
import apiConfig from "../config/apiConfig";
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";

function UsersListInfo() {
  const serverUrl = apiConfig.serverUrl;
  const [listUserInfo, setListUserInfo] = React.useState([]);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [searchField, setSearchField] = React.useState("id");

  const deleteAccount = (userId, userName) => {
    Swal.fire({
      title: `آیا مطمئن هستید؟`,
      text: `می‌خواهید کاربر ${userName} را حذف کنید؟`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'بله، حذف شود',
      cancelButtonText: 'لغو',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(serverUrl + "delete-user-account", { id: userId })
          .then((response) => {
            if (response.data.success) {
              Swal.fire('حذف شد!', 'کاربر با موفقیت حذف شد.', 'success');
              setListUserInfo((prevList) =>
                prevList.filter((user) => user.id !== userId)
              );
            } else {
              Swal.fire('خطا!', 'حذف کاربر با خطا مواجه شد.', 'error');
            }
          })
          .catch((error) => {
            console.error("خطا در حذف کاربر: ", error);
          
            if (error.response && error.response.status === 403) {
              // پیام خطا برای کاربرانی با نوع کاربری owner
              Swal.fire('خطا!', 'حذف کاربران با نوع کاربری owner مجاز نیست.', 'error');
            } else if (error.response && error.response.status === 404) {
              // پیام خطا برای کاربر یافت نشده
              Swal.fire('خطا!', 'کاربر مورد نظر یافت نشد.', 'error');
            } else {
              // پیام خطا برای موارد دیگر
              Swal.fire('خطا!', 'ارتباط با سرور برقرار نشد.', 'error');
            }
          });
          
      }
    });
  };
  const loginToAccount = (userId , app_type) => {
    const formData = new FormData();
    formData.append('userId', userId);
  
    axios.post(serverUrl + "login-user-account", formData)
      .then(response => {
        if (response.data.success) {
          const apiToken = response.data.api_token;
          
          // برای کاربران مشاوره (sub_app)، به پروژه aryadiet-second-main هدایت کن
          if (app_type === 'sub_app') {
            const redirectUrl = `https://appointment.aryadiet.com/admin-login/${apiToken}`;
            window.location.href = redirectUrl;
          } else {
            // برای کاربران رژیم، به پروژه قبلی هدایت کن
            const redirectUrl = `https://diett.aryadiet.com/regime/admin-login/${apiToken}`;
            window.location.href = redirectUrl;
          }
        } 
      
         else {
          // در صورت وجود خطا، پیام مناسب نمایش داده می‌شود
          Swal.fire("خطا!", "ورود به اکانت با مشکل مواجه شد.", "error");
        }
      })
      .catch(error => {
        console.error("خطا در ارسال درخواست: ", error);
        Swal.fire('خطا!', 'ارتباط با سرور برقرار نشد.', 'error');
      });
  };
  
 
  
  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const handleFieldChange = (event) => {
    setSearchField(event.target.value);
  };

  const filteredUsers = listUserInfo.filter((user) => {
    // برای کاربران مشاوره (sub_app)، بر اساس sub_app_packages فیلتر کن
    if (user.app_type == 'sub_app') {
      if (user.countSubAppPackages == 0 || user.countSubAppPackages == null) {
        return false;
      }
    } else {
      // برای کاربران رژیم، بر اساس diet_order فیلتر کن
      if (user.conutDietOrder == 0 || user.conutDietOrder == null) {
        return false;
      }
    }
    
    const fieldValue = user[searchField];
  
    // اگر مقدار فیلد 'searchField' از نوع رشته باشد، از toLowerCase استفاده کن
    if (typeof fieldValue === 'string') {
      return fieldValue.toLowerCase().includes(searchQuery.toLowerCase());
    }
  
    // اگر مقدار فیلد 'searchField' عددی یا دیگر انواع باشد، به عنوان تطابق معتبر قبول کن
    else if (typeof fieldValue === 'number') {
      return fieldValue.toString().includes(searchQuery);
    }
  
    // در صورت null یا undefined، مقدار را فیلتر نکن
    return true;
  });
  
  

  React.useEffect(() => {
    axios
      .get(serverUrl + "get-list-user-info")
      .then((response) => {
        const ListUserInfo = response.data.ListUserInfo;
        setListUserInfo(ListUserInfo);
        console.log(ListUserInfo);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              
            <CardHeader>
  <CardTitle style={{ textAlign: "right" }} tag="h4">
    لیست کاربران
  </CardTitle>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  <select
                  value={searchField}
                  onChange={handleFieldChange}
                  className="form-control"
                  style={{ maxWidth: "150px", borderRadius: "10px" ,marginLeft:'5px'}}
                >
                  <option value="id">شماره پرونده</option>
                  <option value="name_last_name">نام و نام خانوادگی</option>
                  <option value="country">کشور</option>
                  <option value="email">ایمیل</option>
                  <option value="phone_number">شماره تلفن</option>
                  <option value="user_type">نوع کاربر</option>
                  <option value="type_of_diet">نوع رژیم</option>
                  <option value="start_date_en">تاریخ تشکیل پرونده</option>
                </select>
    <input
      type="text"
      className="form-control"
      placeholder="جستجو ..."
      style={{
        maxWidth: "300px",
        marginLeft: "auto",
        textAlign: "right",
        borderRadius: "15px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        padding: "10px",
      }}
      value={searchQuery}
      onChange={(e) => handleSearch(e.target.value)}
    />
     {searchQuery && (
      <span
        style={{
          position: "absolute",
          right: "433px",
          background: "#007bff",
          color: "white",
          borderRadius: "12px",
          padding: "3px 10px",
          fontSize: "12px",
        }}
      >
        {filteredUsers.length}
      </span>
    )}
  </div>
</CardHeader>

    
              <CardBody>
                <Table className="tablesorter" responsive style={{ textAlign: 'right' }}>
                  <thead className="text-primary">
                    <tr>
                      <th>ردیف</th>
                      <th>شماره پرونده</th>
                      <th>نام و نام خانوادگی</th>
                      <th>شماره تلفن</th>
                      <th>ایمیل</th>
                      <th>کشور</th>
                      <th>نوع کاربر</th>
                      <th>نوع رژیم</th>
                      <th>تاریخ تشکیل پرونده</th>
                      <th>شماره دوره</th>
                      <th>ویرایش</th>
                      <th>حذف اکانت</th>
                      <th>منبع</th>
                      <th>ورود به اکانت کاربر</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      filteredUsers.map((info, index) => (
                        <tr key={index} style={{ cursor: 'pointer' }}>
                          <td><Link style={{ color: 'rgb(184 173 173 / 70%)' }} to="/rtl/rtl-get-user-info" state={{ userid: info.id }}>{index + 1}</Link></td>
                          <td><Link style={{ color: 'rgb(184 173 173 / 70%)' }} to="/rtl/rtl-get-user-info" state={{ userid: info.id }}>{info.id}</Link></td>
                          <td><Link style={{ color: 'rgb(184 173 173 / 70%)' }} to="/rtl/rtl-get-user-info" state={{ userid: info.id }}>{info.name_last_name}</Link></td>
                          <td><Link style={{ color: 'rgb(184 173 173 / 70%)' }} to="/rtl/rtl-get-user-info" state={{ userid: info.id }}>{info.phone_number}</Link></td>
                          <td><Link style={{ color: 'rgb(184 173 173 / 70%)' }} to="/rtl/rtl-get-user-info" state={{ userid: info.id }}>{(info.email === 'null' || info.email == null ? 'ثبت نشده' : info.email)}</Link></td>
                          <td><Link style={{ color: 'rgb(184 173 173 / 70%)' }} to="/rtl/rtl-get-user-info" state={{ userid: info.id }}>{(info.country === 'null' || info.country == null ? 'ثبت نشده' : info.country)}</Link></td>
                          <td><Link style={{ color: 'rgb(184 173 173 / 70%)' }} to="/rtl/rtl-get-user-info" state={{ userid: info.id }}>{info.user_type}</Link></td>
                          <td><Link style={{ color: 'rgb(184 173 173 / 70%)' }} to="/rtl/rtl-get-user-info" state={{ userid: info.id }}>{info.type_of_diet}</Link></td>
                          <td><Link style={{ color: 'rgb(184 173 173 / 70%)' }} to="/rtl/rtl-get-user-info" state={{ userid: info.id }}>{info.start_date_en}</Link></td>
                          <td><Link style={{ color: 'rgb(184 173 173 / 70%)' }} to="/rtl/rtl-get-user-info" state={{ userid: info.id }}>{info.app_type === 'sub_app' ? (info.countSubAppPackages || 0) : (info.conutDietOrder || 0)}</Link></td>
                          <td>
                            <Link 
                              to="/rtl/rtl-edit-user-info" 
                              state={{ userid: info.id }}
                              className="btn btn-outline-primary btn-sm" // کلاس‌های بوت‌استرپ برای استایل دکمه
                              style={{ color: 'white' }} // رنگ متن برای تطابق با رنگ دکمه
                            >
                              ویرایش
                            </Link>
                          </td>
                          <td>
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => deleteAccount(info.id, info.name_last_name)}
                              style={{
                                backgroundColor: '#d33',
                                border: 'none',
                                color: 'white',
                                padding: '5px 10px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                              }}
                            >
                              حذف
                            </button>
                          </td>
                          <td style={{ textAlign: "right" }}>
                                <span
                                  style={{
                                    display: "inline-block",
                                    
                                    color: info.app_type === "sub_app" ? "blue" : "green",
                                  }}
                                >
                                  {info.app_type === "sub_app" ? "کاربر مشاوره" : "کاربر رژیم"}
                                  
                                </span>
                              </td>
                          <td>
                            <button
                              onClick={() => loginToAccount(info.id,info.app_type)} 
                              className="btn btn-primary btn-sm"
                              style={{
                                backgroundColor: '#007bff',  
                                border: 'none',  
                                color: 'white',  
                                padding: '8px 15px',  
                                borderRadius: '5px', 
                                cursor: 'pointer',  
                                textAlign: 'center',  
                              }}
                            >
                              ورود به اکانت
                            </button>
                          </td>



                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default UsersListInfo;
